import { render, staticRenderFns } from "./BonEntre.vue?vue&type=template&id=3445d514&"
import script from "./BonEntre.vue?vue&type=script&lang=js&"
export * from "./BonEntre.vue?vue&type=script&lang=js&"
import style0 from "./BonEntre.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports